<template>
    <div v-if="whiteTemplate">
        <span @click.prevent.stop="vote" class="button-rs bg-save valuatedBtn" :class="showText ? 'active' : ''">
            <i :class="isValuated(contentId) ? 'fal fa-folder-minus' : 'fal fa-folder-plus'"></i>
            <span class="text" v-html="isValuated(contentId) ? 'No guardar' : 'Guardar'">Guardar</span>
        </span>

        <transition name="slide-fade">
            <div class="message error" v-if="showError" >
                <p class="textmodal">Para guardar tienes que
                    <a class="register" :href="registerUrl">registrarte</a>. Si ya estás registrado,
                    <a class="login" @click="onLogin" href="javascript:void(0)">inicia sesión</a>
                </p>
                <i class="fa fa-window-close" @click="showError = false"></i>
            </div>
            <div class="message success" v-if="showSuccess" >
                <p class="textmodal">Has guardado, el contenido se ha guardado en
                    <a class="register" :href="profileUrl">tu perfil</a>.
                    <a class="login" :href="profileUrl">Ver contenidos guardados</a>
                </p>
                <i class="fa fa-window-close" @click="showSuccess = false"></i>
            </div>
            <div class="message success" v-if="showSuccessUnSave" >
                <p class="textmodal">Este contenido ya no está en tu lista para leer más tarde.</p>
                <i class="fa fa-window-close" @click="showSuccessUnSave = false"></i>
            </div>
        </transition>
    </div>

    <button v-else @click="toggleShowText" class="button-rs bg-save" :class="showText ? 'active' : ''">
        <i v-if="showText" class="fal fa-times" @click.prevent.stop="toggleShowText"></i>
        <i v-if="!showText" :class="isValuated(contentId) ? 'fal fa-folder-minus' : 'fal fa-folder-plus'"></i>
        <span v-if="showText" @click.prevent.stop="vote">
            <span v-text="isValuated(contentId) ? 'No guardar' : 'Guardar'">Guardar</span>
            <i class="fal fa-chevron-right"></i>
        </span>
        <transition name="slide-fade">
            <div class="message error" v-if="showError" >
                <p class="textmodal">Para guardar tienes que
                    <a class="register" :href="registerUrl">registrarte</a>. Si ya estás registrado,
                    <a class="login" @click="onLogin">inicia sesión</a>
                </p>
                <i class="fa fa-window-close" @click="showError = false"></i>
            </div>
            <div class="message success" v-if="showSuccess" >
                <p class="textmodal">Has guardado, el contenido se ha guardado en
                    <a class="register" :href="profileUrl">tu perfil</a>.
                    <a class="login" :href="profileUrl">Ver contenidos guardados</a>
                </p>
                <i class="fa fa-window-close" @click="showSuccess = false"></i>
            </div>
            <div class="message success" v-if="showSuccessUnSave" >
                <p class="textmodal">El contenido se ha eliminado de
                    <a class="register" :href="profileUrl">tu perfil</a>.
                    <a class="login" :href="profileUrl">Ver contenidos guardados</a>
                </p>
                <i class="fa fa-window-close" @click="showSuccessUnSave = false"></i>
            </div>
        </transition>
    </button>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import user from "../../user";
import { currentMonth, currentYear } from '../util';

  export default {
    name: 'edi-valuation',
    props: {
      contentId: Number,
      whiteTemplate: Boolean
    },
    computed: {
      ...mapGetters([
        'isValuated',
        'totalValuations',
        'profileUrl',
        'loginUrl',
        'redirectUrl',
        'registerUrl'
      ]),
    },
    data() {
      return {
        showError: false,
        showSuccess: false,
        showText: false,
        showSuccessUnSave: false
      }
    },
    methods: {
      ...mapActions([
        'valuate',
        'undoValuation',
        'checkValuatedContents'
      ]),
      ...mapMutations([
        'INIT_VALUATIONS',
        'VALUATE',
        'UNDO_VALUATION'
      ]),
      hideMsg() {
        setTimeout(() => {
          this.showError = false;
          this.showSuccess = false;
          this.showSuccessUnSave = false;
        }, 5000);
      },
      toggleShowText() {
          this.showText = !this.showText;
      },
      async vote() {
        // Si no esta logeado no hacemos peticion.
        if (!user.isLogged) {
            console.log("No hay una sesion de usuario");
            this.showError = true;
            return false;
        }

        if (this.isValuated(this.contentId)) {
          const { success, errorCode } = await this.undoValuation(this.contentId);
          if (success) {
            this.UNDO_VALUATION();
            this.showSuccessUnSave = true;
          }
          if (errorCode) {
            // En el caso de querer eliminar un valuation que ya no existe mostramos un mensaje correcto
            if (errorCode === "valuationNotFound") {
                this.UNDO_VALUATION();
                this.showSuccessUnSave = true;
                // Eliminamos el contenido de la lista
                let likes = localStorage.getItem(`likes_${currentYear}_${currentMonth}`);
                likes = likes.split(',');
                if (likes.length > 0) {
                    likes.forEach((contentId, index) => {
                        if (parseInt(contentId) === this.contentId) {
                            likes.splice(index, 1);
                        }
                    });
                }

                localStorage.setItem(`likes_${currentYear}_${currentMonth}`, likes.filter(like => like !== "").join(','));
            } else {
                this.showError = true;
            }
          }
          this.hideMsg();
        } else {
          const { success, errorCode } = await this.valuate(this.contentId);
          if (success) {
            this.VALUATE();
            this.showSuccess = true;
          }
          if (errorCode) {
            // Si ocurre un caso de duplicado mostramos un mensaje correcto
            if (errorCode === "duplicateValuation") {
                this.VALUATE();
                this.showSuccess = true;
                // Lo añadimos a la lista
                if (!this.isValuated(this.contentId)) {
                    let likes = localStorage.getItem(`likes_${currentYear}_${currentMonth}`);
                    likes = likes.split(',');
                    likes.push(this.contentId);
                    localStorage.setItem(`likes_${currentYear}_${currentMonth}`, likes.filter(like => like !== "").join(','));
                }
            } else {
                this.showError = errorCode;
            }
          }
          this.hideMsg();
        }
      },
      // Usamos esta función en lugar de un :href="loginUrl" porque usando esta url de redirectUrl
      // una vez logeado, el usuario es redirigido a la página en la que estaba
      // de lo contrario una vez logeado sería llevado a la página principal
      onLogin() {
        fetch(`${this.redirectUrl}?op=saveref`, { method: 'GET' })
          .then(res => {
            // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
            // validar el estado de la respuesta, pero el servicio de api
            // de callback devuelve siempre 404, así que no comprobamos nada.
            window.location.href = this.loginUrl;
          })
          .catch(err => {
            // sólo si err.status === 50x
            console.log(err);
          });
      },
    },
    mounted() {
      this.INIT_VALUATIONS(this.valuations);
      this.checkValuatedContents();
    }
  }
</script>

<style>
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
